import { useMutation, useQueryClient } from '@tanstack/react-query';
import { putFetch } from '@legacy/utils/fetcher';
import { MOVE_HOURS_KEY } from '../get/getMoveHoursAPI';

const MOVE_HOURS_URL_PATH = '/api/v2/adjustments/move-hours';
export const PUT_MOVE_HOURS_MSW_STATUS_KEY = 'putMoveHoursAPI';

interface IUpdateModel {
  targetTaskId: number;
}

const updateMoveHours = ({
  timeRegistrationIds,
  updateModel,
}: {
  timeRegistrationIds: string[];
  updateModel: IUpdateModel;
}) =>
  putFetch({
    path: `${MOVE_HOURS_URL_PATH}?timeRegistrationIds=${timeRegistrationIds
      .map((project) => project)
      .join(',')}`,
    key: PUT_MOVE_HOURS_MSW_STATUS_KEY,
    body: JSON.stringify(updateModel),
  });

export const useUpdateMoveHours = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateMoveHours,

    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [MOVE_HOURS_KEY],
      });
    },
  });
};
